export default {
    table: {
        qf_formProcessStatusOnly: 'Formularstatus',
        qf_processStatusOnly: 'Maßnahmenstatus',
        qf_signedOnly: 'Unterschrift',
        qf_eventOnly: 'Maßnahme',
        qf_eventPersonOnly: 'Personen',
        qf_executedProgramOnly: 'Programmnachweis',
        qf_formProcessOnly: 'Formular',
        qf_documentsOnly: 'Dokumente',
        qf_mailsOnly: 'E-Mails',
    }
}